import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import Signup from "./Signup";

export default function StartupApply() {
  const { user } = useAuth();
  if (user?.role === "startup") return <Navigate to="/startup/profile" replace />;
  if (user && user.role !== "startup") return <Navigate to="/marketplace" replace />;
  // Show signup pre-set to startup
  window.history.replaceState(null, "", "/signup?role=startup");
  return <Signup />;
}
